import { Capacitor } from '@capacitor/core';

export function isIos(): boolean {
	return Capacitor.getPlatform() === 'ios';
}

export function isAndroid(): boolean {
	return Capacitor.getPlatform() === 'android';
}

export function isFirefox(): boolean {
	return /firefox/i.test(navigator.userAgent);
}

export function isIphone(): boolean {
	if (Capacitor.getPlatform() === 'ios') {
		return !isIpad();
	}
	return false;
}

export function isSafari(): boolean {
	return /Safari\//i.test(navigator.userAgent) && !/Chrome/i.test(navigator.userAgent);
}

export function isIpad(): boolean {
	if (Capacitor.getPlatform() === 'ios') {
		return (
			/iPad/i.test(navigator.userAgent) ||
			(navigator.maxTouchPoints > 1 && /Macintosh/i.test(navigator.userAgent))
		);
	}
	return false;
}

export function getBrowserName(): string {
	const ua = navigator.userAgent;

	if (/OPR\//i.test(ua)) return 'opera';
	if (/Edg\//i.test(ua)) return 'edge';
	if (/Chrome\//i.test(ua) && !/Chromium/i.test(ua)) return 'chrome';
	if (/Safari\//i.test(ua) && !/Chrome/i.test(ua)) return 'safari';
	if (/Firefox\//i.test(ua)) return 'firefox';

	return 'unknown';
}

export function getPlatformName(): string {
	if (Capacitor.isNativePlatform()) {
		return Capacitor.getPlatform();
	}

	const ua = navigator.userAgent;

	if (/Android/i.test(ua)) return 'android';
	if (/iPad|iPhone|iPod/i.test(ua)) return 'ios';
	if (/Win/i.test(ua)) return 'win';
	if (/Linux/i.test(ua)) return 'linux';
	if (/Mac/i.test(ua)) return 'mac';

	return 'unknown';
}

export function isScreenGtSm(): boolean {
	return typeof window !== 'undefined' && window.innerWidth > 1023;
}
